export default (file) => {
  return () => import('@/views/' + file);
};
